/**
 * Portal Manta · TipPage
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { V, fmtMi, fmtBR, isAmpliacao } from '../../globals.js';
import { CapexHero } from '../charts/CapexHero.jsx';
import { COR } from '../../data/cor.js';

const TipPage = memo(function TipPage_Inner({lote}){
  const tips=(lote.tipologias||[]).filter(isAmpliacao);
  const total=tips.reduce((s,t)=>s+(t.v||0),0);
  return(<div style={{padding:'14px 17px',overflowY:'auto',flex:1}}>
    <div style={{fontSize:14,fontWeight:700,color:V.br,marginBottom:4}}>Tipologias</div>
    <div style={{fontSize:10.5,color:V.g4,marginBottom:12}}>CAPEX por tipologia · R$ Mi · base {lote.data_base}</div>
    <CapexHero lote={lote}/>

    <div style={{background:'#fff',border:`1px solid ${V.g2}`,borderRadius:12,overflow:'hidden'}}>
      <table style={{width:'100%',borderCollapse:'collapse'}}>
        <thead><tr style={{background:V.g1}}>
          <th style={{padding:'8px 12px',textAlign:'left',fontSize:10.5,fontWeight:700,color:V.g5}}>Cod</th>
          <th style={{padding:'8px 12px',textAlign:'left',fontSize:10.5,fontWeight:700,color:V.g5}}>Descrição</th>
          <th style={{padding:'8px 12px',textAlign:'right',fontSize:10.5,fontWeight:700,color:V.g5}}>R$ Mi</th>
          <th style={{padding:'8px 12px',textAlign:'right',fontSize:10.5,fontWeight:700,color:V.g5}}>%</th>
          <th style={{padding:'8px 12px',textAlign:'right',fontSize:10.5,fontWeight:700,color:V.g5}}>Qtd</th>
          <th style={{padding:'8px 12px',textAlign:'right',fontSize:10.5,fontWeight:700,color:V.g5}}>Un</th>
          <th style={{padding:'8px 12px',textAlign:'right',fontSize:10.5,fontWeight:700,color:V.bl}}>Custo Unitário</th>
        </tr></thead>
        <tbody>{tips.map((t,i)=>{
          const c=COR[t.g]||{bar:V.g4,bg:V.g1,text:V.g5};
          const pct2=total>0?((t.v||0)/total*100):0;
          const cu=(t.qtd!=null&&t.qtd>0)?(t.v*1e6/t.qtd):null;
          return(<tr key={i} style={{borderBottom:`1px solid ${V.g1}`,background:i%2===0?'#fff':V.g0}}>
            <td style={{padding:'6px 12px',fontSize:10,fontFamily:'monospace',color:V.g4}}>{t.cod}</td>
            <td style={{padding:'6px 12px'}}><span style={{display:'inline-block',padding:'1px 6px',borderRadius:4,fontSize:10,fontWeight:600,background:c.bg,color:c.text}}>{t.desc}</span></td>
            <td style={{padding:'6px 12px',textAlign:'right',fontSize:11,fontWeight:600,color:V.br,fontFamily:'monospace'}}>{fmtMi(t.v)}</td>
            <td style={{padding:'6px 12px',textAlign:'right',fontSize:10,color:V.g5}}>{pct2.toFixed(1)}%</td>
            <td style={{padding:'6px 12px',textAlign:'right',fontSize:10,color:V.g5,fontFamily:'monospace'}}>{t.qtd!=null?t.qtd:'—'}</td>
            <td style={{padding:'6px 12px',textAlign:'right',fontSize:10,color:V.g4}}>{t.u}</td>
            <td style={{padding:'6px 12px',textAlign:'right',fontSize:10,fontFamily:'monospace',color:cu!=null?V.bl:V.g3,fontWeight:cu!=null?600:400}}>{cu!=null?fmtBR(cu)+' /'+t.u:'—'}</td>
          </tr>);
        })}</tbody>
        <tfoot><tr style={{background:V.g1}}>
          <td colSpan={2} style={{padding:'7px 12px',fontSize:11,fontWeight:700,color:V.br}}>TOTAL</td>
          <td style={{padding:'7px 12px',textAlign:'right',fontSize:12,fontWeight:700,color:V.or,fontFamily:'monospace'}}>{fmtMi(total)}</td>
          <td colSpan={4}></td>
        </tr></tfoot>
      </table>
    </div>
  </div>);});

export { TipPage };
export default TipPage;
